export const GeneralLoginFlowTestIds = {
  spinnerBackdrop: 'spinner_backdrop'
} as const;
